import { postRequestMall } from './request/request'
import { IFlushConfirmRed, IFlushData } from "@/api/types/voucherTypes";
import { IVoucherList } from '@/@types/types'

// 获取代金券列表(废弃)
// export const apiGetVoucherList = (params?: any) => postRequestMall('/benefit/receiveList', params)

// 领取优惠券(废弃)
// export const apiGetVoucher = (params?: any) => postRequestMall('/benefit/receive', params)

// 获取可用的代金券
export const apiGetUseVoucherList = (params?: any) => postRequestMall('/benefit/useList', params)

// 获取banner 图
export const apiGetBanner = (params?: any) => postRequestMall('/game/role/getBanner', params)

// 获取冻结代金券列表
export const apiGetLockVoucherList = (params: IFlushConfirmRed) =>
  postRequestMall('/benefit/lockBenefits', params)

// 刷新角色代金券数据
export const apiFlushConfirm = (params: IFlushConfirmRed) =>
  postRequestMall<IFlushData>('/game/role/flushConfirm', params, false, false)

// 获取距离获得下一个代金券
export const apiGetNextBenefits = (params?: any) =>
  postRequestMall<IVoucherList[]>('/benefit/nextBenefits', params)

// 支付成功后获得的代金券
export const apiGetVoucherByPay = (params?: any) =>
  postRequestMall<any>('/benefit/orderBenefits', params)
